import { Dates } from "../util/dates";
import { Company } from "./company";
import { ProductPolicy } from "./product-policy";
import { User } from "./user";

export class PolicyTarget {
  id: string;
  policyId: string;
  targetId: string;
  targetType: string;
  targetName: string;
  group: Company;
  user: User;
  policy: ProductPolicy;
  startDate: Date;
  endDate: Date;

  constructor(obj?: any) {
    const model = obj || {};
    Object.assign(this, model);

    this.group = model.group ? new Company(model.group) : null;
    this.user = model.user ? new User(model.user) : null;
    this.startDate = model.startDate ? new Date(model.startDate) : null;
    this.endDate = model.endDate ? new Date(model.endDate) : null;
  }

  public get userName(): string {
    return this.targetType === 'USER' ? this.user?.toDisplayName(true, false) : '';
  }

  public get groupName(): string {
    return this.targetType === 'USER' ? this.user?.company?.name : this.group?.name;
  }

  public get displayTargetName(): string {
    if (this.targetName) {
      return this.targetName;
    } else if (this.targetType === 'GROUP') {
      return this.group?.name;
    } else if (this.targetType === 'USER') {
      return `${this.user?.toDisplayName(false, true)} ${this.user?.email}`;
    }
    
    return null;
  }

  public get periods(): string {
    if (!this.startDate && !this.endDate) {
      return "무제한";
    } else if (!this.startDate && this.endDate) {
      return `~ ${Dates.toDateString(this.endDate)}`;
    } else if (this.startDate && !this.endDate) {
      return `${Dates.toDateString(this.startDate)} ~`;
    } else {
      return `${Dates.toDateString(this.startDate)} ~ ${Dates.toDateString(this.endDate)}`;
    }
  }

}
